import { useContext, useEffect, useRef, useState } from "react";
import CurrentContext from "../../../utils/CurrentContext";
import { isAndroid, isIphone } from "../../../helpers/jsHelper";

export const ModelViewerCustom = ({ url, setUrl, setLoading, setRef = null }) => {
  const btnRef = useRef();
  const modRef = useRef();
  const { setIsAR, setIsARReady } = useContext(CurrentContext);
  const [modelLoading, setModelLoading] = useState(true);

  const handleLoadModel = () => {
    setModelLoading(false);
    // console.log("Model has finished loading.", url);

    if (url && btnRef.current) {
        btnRef?.current?.click?.();
        // console.log("Button Clicked 1");
        // console.log("Button Clicked");
        setTimeout(() => {
          setLoading(false);
          setIsAR(false);
      
          // setARUnicode(null)
          // setARModelSrc(null)
          if (!isAndroid() && !isIphone()) {
            setUrl(null);
            setIsARReady(false);
          }
        }, 5000);
      }      
  };

  useEffect(() => {
    if (url && modRef?.current) {
      console.log("dEBUG___url", url);
      modRef?.current?.addEventListener("load", handleLoadModel);
    }
    return () => {
      modRef?.current?.removeEventListener("load", handleLoadModel);
    };
  }, [modRef?.current, url]);

  useEffect(() => {
    if (modRef?.current && setRef) setRef(modRef?.current);
  }, [modRef?.current, setRef]);

  if (!url) return;

//   console.log(url, setUrl, setLoading, "DEBUG___modalViewer");

  return (
    <>
      {/* <AnimatedLoader loading={modelLoading} backDrop="transparent" /> */}
      <model-viewer
        id="model-viewer"
        src={url}
        // src={"https://media-staging-v2.livefurnish.com/media/public/cfg/4327/7841/2953/scene/4435/ar_glb/a3f2b6c1_model.glb"}
        alt="maine-cottage"
        //   ar-modes="webxr quick-look scene-viewer"
          // ar-modes="webxr quick-look"
         ar-modes="scene-viewer webxr quick-look"
        orientation={"0 0 0 1"}
        camera-controls
        ar
        ar-scale="auto"
        // poster={getCurrentProductThumbnail()}
        shadow-intensity="1"
        ref={modRef}
        // loading="eager"
        // loading="lazy"
        style={{
          width: "100%",
          // height: 0,
        }}
      >
        <button
          slot="ar-button"
          id="ar-button"
          ref={btnRef}
          style={{ padding: "10px", display: "none" }}
        ></button>
      </model-viewer>
      <button
        style={{
            textDecoration: "none",
            cursor: "pointer",
            color: "#000",
            width: "auto",
            padding: "6px 12px",
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            background: "#f2f2f2",
            border: "1px solid #e0e0e0",
            borderRadius: 16,
            boxShadow: "0px 0px 4px 1px rgba(140, 140, 140, 0.25)",
            margin: "0 auto",
          }}
        onClick={() => handleLoadModel()}
      >
        <span
         >
          View in your space
        </span>
      </button>
    </>
  );
};
